import { getConstant } from '../utils';

export const getCalculatorsNormRegionCulture = getConstant('GET_CALCULATORS_NORM_REGION_CULTURE');
export const getCalculatorNormRegionCultureItem = getConstant('GET_CALCULATORS_NORM_REGION_CULTURE_ITEM');
export const getCalculatorsRBRegionCulture = getConstant('GET_CALCULATORS_RB_REGION_CULTURE');
export const getCalculatorRBRegionCultureItem = getConstant('GET_CALCULATORS_RB_REGION_CULTURE_ITEM');